import { BaseEvents } from '@/shared/utils';

export const DynamicPageEventKeys = {
  checkout: {
    getSubscription: 'checkout/get-subscription',
    getGuestSubscription: 'checkout/get-guest-subscription',
  },
  redirects: {
    to: 'redirects/to',
    back: 'redirects/back',
  },
  subscription: {
    list: 'subscription/list',
  },
} as const;

export interface DynamicPageEvents extends BaseEvents {
  'checkout/get-subscription': {
    priceId: string;
    price: number;
    name: string;
    trialPeriodDays?: number | null;
    couponName?: string | null;
  };
  'checkout/get-guest-subscription': {
    priceId: string;
    price: number;
    name: string;
    trialPeriodDays?: number | null;
    email: string;
    couponName?: string | null;
  };
  'subscription/list': void;
  'redirects/to': { url: string; isExternalPage: boolean };
  'redirects/back': void;
}
